
{
  "familyId": "MET-LEN-METEN",
  "questions": [
    {
      "id": "MET-LEN-METEN-001",
      "familyId": "MET-LEN-METEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_meten",
      "questionType": "multiple_choice",
      "question": "Je meet een potlood met een liniaal. Het begin van het potlood ligt bij 0 cm en het einde bij 17 cm. Hoe lang is het potlood?",
      "context": null,
      "options": ["17 cm", "16 cm", "18 cm", "17 mm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 20,
            "step": 1,
            "unit": "cm",
            "markers": [{"value": 0, "label": "begin"}, {"value": 17, "label": "einde"}],
            "highlightRange": [0, 17]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meten met een liniaal",
            "content": "Leg het voorwerp met het begin bij 0 cm. Lees af waar het einde ligt. De lengte = eindwaarde − beginwaarde. Als het begin bij 0 ligt: lengte = eindwaarde.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "meten_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Het potlood begint bij 0 cm en eindigt bij 17 cm. De lengte is 17 − 0 = 17 cm. Waarom trek je af? Omdat de lengte het verschil is tussen het einde en het begin. Als het begin bij 0 ligt, is het simpel: de lengte is gewoon het eindgetal.",
        "solutionSteps": [
          "Lees het begin af: 0 cm",
          "Lees het einde af: 17 cm",
          "Bereken de lengte: 17 − 0 = 17 cm"
        ],
        "distractorExplanations": {
          "0": "Goed! Van 0 tot 17 cm = 17 cm. Bij 0 als begin is de lengte gelijk aan het eindgetal.",
          "1": "Je dacht waarschijnlijk dat je 1 moet aftrekken. Maar de lengte is einde − begin = 17 − 0 = 17 cm. Onthoud: als het begin bij 0 ligt, is de lengte gewoon het eindgetal.",
          "2": "Je dacht waarschijnlijk dat je 1 moet optellen. Maar de lengte is einde − begin = 17 − 0 = 17 cm, niet 18 cm. Onthoud: niet optellen, gewoon aflezen.",
          "3": "Je dacht waarschijnlijk aan millimeters. Maar 17 mm is maar 1,7 cm — veel te kort voor een potlood. Het potlood is 17 cm lang. Onthoud: let op de eenheid!"
        }
      }
    },
    {
      "id": "MET-LEN-METEN-002",
      "familyId": "MET-LEN-METEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_meten",
      "questionType": "multiple_choice",
      "question": "Je meet een gum, maar het begin ligt niet bij 0. Het begin ligt bij 3 cm en het einde bij 7 cm. Hoe lang is de gum?",
      "context": null,
      "options": ["4 cm", "7 cm", "3 cm", "10 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 10,
            "step": 1,
            "unit": "cm",
            "markers": [{"value": 3, "label": "begin"}, {"value": 7, "label": "einde"}],
            "highlightRange": [3, 7]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meten als het begin niet bij 0 ligt",
            "content": "Als het voorwerp niet bij 0 begint, trek je de beginwaarde af van de eindwaarde:\nlengte = einde − begin\nHier: 7 − 3 = 4 cm.\nDit is de belangrijkste meetregel!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "meten_niet_bij_nul",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De gum begint bij 3 cm en eindigt bij 7 cm. Lengte = einde − begin = 7 − 3 = 4 cm. Waarom aftrekken? Omdat je niet het eindgetal aflest, maar het verschil berekent. Als je alleen het eindgetal (7) neemt, vergeet je dat het voorwerp pas bij 3 begint.",
        "solutionSteps": [
          "Lees het begin af: 3 cm",
          "Lees het einde af: 7 cm",
          "Bereken de lengte: 7 − 3 = 4 cm"
        ],
        "distractorExplanations": {
          "0": "Goed! 7 − 3 = 4 cm. Altijd aftrekken als het begin niet bij 0 ligt.",
          "1": "Je dacht waarschijnlijk dat je gewoon het eindgetal aflest. Maar 7 cm is waar het einde op de liniaal ligt, niet de lengte. Onthoud: lengte = einde − begin = 7 − 3 = 4 cm.",
          "2": "Je dacht waarschijnlijk dat het begingetal de lengte is. Maar 3 cm is waar het voorwerp begint op de liniaal. Onthoud: lengte = einde − begin = 7 − 3 = 4 cm.",
          "3": "Je dacht waarschijnlijk dat je moet optellen: 3 + 7 = 10. Maar bij meten trek je af: 7 − 3 = 4 cm. Onthoud: lengte = einde − begin, niet einde + begin."
        }
      }
    },
    {
      "id": "MET-LEN-METEN-003",
      "familyId": "MET-LEN-METEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_meten",
      "questionType": "multiple_choice",
      "question": "Tussen twee streepjes op een liniaal zit 1 mm. Hoeveel mm zitten er tussen 0 cm en 1 cm?",
      "context": null,
      "options": ["10 mm", "1 mm", "100 mm", "5 mm"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Centimeter en millimeter",
            "content": "1 cm = 10 mm. Op een liniaal zie je 10 kleine streepjes tussen elke cm. Elk streepje = 1 mm. Dit is een basisregel om te onthouden!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "meten_mm_cm",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "1 cm = 10 mm. Op de liniaal zie je 10 kleine streepjes tussen 0 en 1 cm. Elk streepje is 1 mm. Waarom is dit handig? Omdat je hiermee nauwkeuriger kunt meten dan alleen in centimeters.",
        "solutionSteps": [
          "Onthoud de basisregel: 1 cm = 10 mm",
          "Tel de streepjes op de liniaal tussen 0 en 1 cm: 10 streepjes",
          "Elk streepje = 1 mm, dus 10 streepjes = 10 mm ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1 cm = 10 mm. Dit is een van de belangrijkste meetregels.",
          "1": "Je dacht waarschijnlijk dat er maar 1 mm tussen 0 en 1 cm zit. Maar 1 mm is de afstand tussen twee streepjes. Tussen 0 en 1 cm zitten 10 streepjes = 10 mm. Onthoud: 1 cm = 10 mm.",
          "2": "Je dacht waarschijnlijk dat 1 cm = 100 mm. Maar dat klopt niet — 100 mm = 10 cm. Tussen 0 en 1 cm zitten 10 mm. Onthoud: cm naar mm = ×10, niet ×100.",
          "3": "Je dacht waarschijnlijk aan een halve centimeter. 5 mm = 0,5 cm, maar de vraag is hoeveel mm in 1 hele cm. Dat zijn er 10. Onthoud: 1 cm = 10 mm."
        }
      }
    },
    {
      "id": "MET-LEN-METEN-004",
      "familyId": "MET-LEN-METEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_meten",
      "questionType": "multiple_choice",
      "question": "Een leerling meet een boek en zegt: 'Het boek is 24 cm en 5 streepjes.' Hoe lang is het boek in mm?",
      "context": null,
      "options": ["245 mm", "24,5 mm", "295 mm", "240 mm"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cm en mm combineren",
            "content": "24 cm = 240 mm. Plus 5 streepjes (= 5 mm) = 245 mm.\nOf: 24 cm en 5 mm = 24,5 cm = 245 mm.\nOnthoud: 1 cm = 10 mm, dus cm × 10 + extra mm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "meten_cm_mm_combi",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "24 cm = 240 mm (want 24 × 10 = 240). Plus 5 streepjes (= 5 mm) = 245 mm. Je kunt ook schrijven: 24,5 cm. Waarom werkt dit? Elk streepje op de liniaal is 1 mm, en 1 cm = 10 mm. Dus je rekent de centimeters om en telt de losse millimeters erbij op.",
        "solutionSteps": [
          "Reken de centimeters om: 24 cm = 24 × 10 = 240 mm",
          "Tel de extra streepjes erbij: 5 streepjes = 5 mm",
          "Totaal: 240 + 5 = 245 mm",
          "Controleer: 245 mm = 24,5 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 24 cm en 5 mm = 240 + 5 = 245 mm.",
          "1": "Je dacht waarschijnlijk dat je de komma gewoon verplaatst. Maar 24,5 mm is veel te kort (minder dan 3 cm!). Het boek is 245 mm. Onthoud: 24 cm = 240 mm, niet 24 mm.",
          "2": "Je dacht waarschijnlijk dat 5 streepjes = 55 mm. Maar elk streepje is 1 mm, dus 5 streepjes = 5 mm. 240 + 5 = 245 mm, niet 295 mm.",
          "3": "Je dacht waarschijnlijk dat je de streepjes niet meetelt. Maar 240 mm = 24 cm precies. Er zijn nog 5 streepjes (= 5 mm) extra: 240 + 5 = 245 mm."
        }
      }
    },
    {
      "id": "MET-LEN-METEN-005",
      "familyId": "MET-LEN-METEN",
      "module": "Metriek",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_meten",
      "questionType": "fill_in",
      "question": "Een paperclip is 3 cm en 2 mm lang. Hoeveel mm is dat in totaal? Typ het aantal.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["32", "32 mm", "32mm"],
        "caseSensitive": false,
        "placeholder": "... mm"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omrekenen naar mm",
            "content": "3 cm = 30 mm (want 3 × 10 = 30). Plus 2 mm = 32 mm.\nOnthoud: cm naar mm = × 10, dan de losse mm erbij optellen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "meten_omrekenen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "3 cm = 3 × 10 = 30 mm. Plus 2 mm = 32 mm. Waarom × 10? Omdat 1 cm = 10 mm. Dus elke centimeter bevat 10 millimeters. Controleer: 32 mm = 3,2 cm ✓",
        "solutionSteps": [
          "Reken de centimeters om: 3 cm = 3 × 10 = 30 mm",
          "Tel de extra mm erbij: 30 + 2 = 32 mm",
          "Controleer: 32 mm = 3,2 cm ✓"
        ]
      }
    }
  ]
}
